// extracted by mini-css-extract-plugin
export var closeButton = "_d0-1";
export var closeX = "_d0-3";
export var container = "_d0-0";
export var image = "_d0-2";